// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"7df9528f","538":"7dc5201b"}[chunkId] + ".chunk.js";
};